import type { FC } from 'react'
import { differenceInCalendarDays, format, isSameDay, isValid, parseISO } from 'date-fns'
import { Box } from '@mui/material'
import { red, yellow } from '@mui/material/colors'

interface TaskDueDateProps {
  dueDate?: string | Date | null
  isComplete: boolean
  withoutDueText?: boolean
}

const TaskDueDate: FC<TaskDueDateProps> = (props: TaskDueDateProps) => {
  // Given a due date and task completion, returns a due date label
  const dueText = props.withoutDueText ? '' : 'Due'
  const dueDate = !props.dueDate
    ? null
    : typeof props.dueDate === 'string'
      ? parseISO(props.dueDate)
      : props.dueDate
  if (!dueDate || !isValid(dueDate)) return null
  const formatted = format(dueDate, 'EEE, MMM. d, yyyy')
  const diff = differenceInCalendarDays(dueDate, new Date())

  let when = formatted
  let tone: string | undefined
  if (diff < -1) {
    tone = red[400]
  } else if (diff === -1) {
    when = 'Yesterday'
    tone = red[400]
  } else if (isSameDay(dueDate, new Date())) {
    when = 'Today'
    tone = yellow[700]
  } else if (diff === 1) {
    when = 'Tomorrow'
  }

  const toneColor = props.isComplete ? undefined : tone

  return (
    <Box component="span" sx={{ color: toneColor }}>
      <Box component="span" sx={{ fontWeight: 800, paddingRight: '.5em' }}>
        {dueText}
      </Box>
      {when}
    </Box>
  )
}

export default TaskDueDate
